import { css } from 'styled-components';
import { WhiteBackgroundProps } from './models';

import element1 from '~/assets/white-background/blue-left-bottom.svg';
import element2 from '~/assets/white-background/blue-left-top.svg';
import element4 from '~/assets/white-background/orange-right-center.svg';
import element5 from '~/assets/white-background/outlined-blue-left-bottom.svg';
import element6 from '~/assets/white-background/red-right-top.svg';
import element3 from '~/assets/white-background/outlined-right-center-circle.svg';
import element7 from '~/assets/white-background/petal.svg';

const imageBase = css`
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  background-attachment: scroll;
`;

export const WhiteBackground = css<WhiteBackgroundProps>(({ theme }) => {
  return css`
    background-color: ${theme.colors.white};
    height: 100%;
    width: 100%;
    position: fixed;
    overflow: hidden;
    z-index: -1;

    > .element {
      ${imageBase};
      position: absolute;
    }

    > .element-1 {
      background-image: url(${element1});

      @media only screen and ${theme.device.laptopM} {
        height: 186px;
        width: 188px;
        left: -30px;
        top: 380px;
        z-index: 10;
      }

      @media only screen and ${theme.device.max.laptopM} and ${theme.device.mobileXL} {
        height: 200px;
        width: 200px;
        left: -79px;
        bottom: -32px;
      }

      @media only screen and ${theme.device.max.mobileXL} {
        height: 115px;
        width: 115px;
        left: -48px;
        bottom: 134px;
      }
    }

    > .element-2 {
      @media only screen and ${theme.device.mobileXL} {
        background-image: url(${element2});
        width: 127px;
        height: 162px;
        top: -90px;
        left: 44px;
      }
    }

    > .element-3 {
      @media only screen and ${theme.device.laptopM} {
        background-image: url(${element3});
        height: 250px;
        width: 250px;
        right: -50px;
        bottom: -30px;
      }
    }

    > .element-4 {
      @media only screen and ${theme.device.laptopM}, ${theme.device.max.mobileXL} {
        background-image: url(${element4});
      }

      @media only screen and ${theme.device.laptopM} {
        top: 400px;
        right: 50px;
        height: 86px;
        width: 90px;
        z-index: 10;
        transform: rotate(90deg);
      }

      @media only screen and ${theme.device.max.mobileXL} {
        height: 53px;
        width: 65px;
        left: -39px;
        top: 15px;
        transform: rotate(76deg);
      }
    }

    > .element-5 {
      background-image: url(${element5});

      @media only screen and ${theme.device.laptopM} {
        height: 355px;
        width: 361px;
        left: -110px;
        top: 230px;
      }

      @media only screen and ${theme.device.max.laptopM} and ${theme.device.mobileXL} {
        height: 50px;
        width: 50px;
        left: -10px;
        top: 470px;
      }

      @media only screen and ${theme.device.max.mobileXL} {
        height: 65px;
        width: 64px;
        left: -12px;
        bottom: 130px;
      }
    }

    > .element-6 {
      background-image: url(${element6});

      @media only screen and ${theme.device.laptopM} {
        height: 145px;
        width: 147px;
        right: -30px;
        top: 30px;
      }

      @media only screen and ${theme.device.max.laptopM} and ${theme.device.mobileXL} {
        height: 140px;
        width: 140px;
        top: 14px;
        right: -45px;
      }

      @media only screen and ${theme.device.max.mobileXL} {
        display: none;
      }
    }
  `;
});
